import makeResolveGetterValuesFunc from 'common/util/makeResolveGetterValuesFunc';
import { getHouseholdPets } from 'common/householdHelpers';

export const leaseTemplateDefinitions = [
  {
    title: 'Lease Document',
    templateFieldId: 'leaseAgreementTemplateId',
    enabled: true,
  },
  {
    title: 'Mold Addendum',
    templateFieldId: 'moldAddendumTemplateId',
    isAddenda: true,
    enabled: true,
  },
  {
    title: 'Bed Bug Addendum',
    templateFieldId: 'bedBugAddendumTemplateId',
    isAddenda: true,
    enabled: true,
  },
  {
    title: 'Flood Disclosure Addendum',
    templateFieldId: 'floodDisclosureTemplateId',
    isAddenda: true,
    enabled: true,
  },
  {
    title: 'Inventory & Condition Form',
    templateFieldId: 'inventoryConditionTemplateId',
    isAddenda: true,
    enabled: true,
  },
  {
    title: 'Residential Guaranty',
    templateFieldId: 'residentialGuarantyTemplateId',
    isAddenda: true,
    enabled: ({ guarantors }) => guarantors.length > 0,
  },
  {
    title: 'Pet Agreement',
    templateFieldId: 'petAgreementTemplateId',
    isAddenda: true,
    enabled: ({ applications }) => {
      const { pets } = getHouseholdPets({ householdApplications: applications });
      return pets.length > 0;
    },
  },
  {
    title: 'LBP-Pamphlet',
    templateFieldId: 'lbpPamphletTemplateId',
    enabled: ({ listing }) => listing.yearBuilt <= 1978,
  },
  {
    title: 'Lead Addendum',
    templateFieldId: 'leadAddendumTemplateId',
    isAddenda: true,
    enabled: ({ listing, householdListing }) => {
      return (
        listing?.yearBuilt <= 1978 ||
        (householdListing?.additionalAddenda &&
          householdListing.additionalAddenda.includes(
            `Lead Addendum (built in ${listing.yearBuilt})`,
          ))
      );
    },
  },
  {
    title: 'Pool/Spa Maintenance Addendum',
    templateFieldId: 'poolSpaMaintenanceTemplateId',
    isAddenda: true,
    enabled: ({ householdListing }) => {
      return householdListing?.additionalAddenda?.includes('Pool/Spa Maintenance Addendum');
    },
  },
];

export const getLeaseTemplates = ({ applications, guarantors, listing, householdListing = {} }) => {
  const resolveGetterValues = makeResolveGetterValuesFunc({
    applications,
    guarantors,
    listing,
    householdListing,
  });
  return leaseTemplateDefinitions.map(resolveGetterValues);
};
